"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { TooltipTrigger } from '../../../Tooltip/components/TooltipTrigger/TooltipTrigger.mjs';
import { Tooltip } from '../../../Tooltip/Tooltip.mjs';
import { Button } from '../../../Button/Button.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconHide } from '../../../Icon/components/icons/IconHide.mjs';
import { IconShow } from '../../../Icon/components/icons/IconShow.mjs';
import { Action } from '../../../Action/Action.mjs';
import locales from '../../../../../../_virtual/_.locale.json@95341064edeb0e38b66d786dbd62955c.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const TogglePasswordVisibilityButton = ({
  isVisible,
  isDisabled = false,
  onPress,
  className
}) => {
  const translate = useLocalizedStringFormatter(locales);
  const icon = isVisible ? /* @__PURE__ */ jsx(IconHide, {}) : /* @__PURE__ */ jsx(IconShow, {});
  const tooltipText = translate.format(
    "button.generate.tooltip." + (isVisible ? "hide" : "show")
  );
  return /* @__PURE__ */ jsx(Action, { action: onPress, children: /* @__PURE__ */ jsx(TooltipTrigger, { children: /* @__PURE__ */ jsxs(
    Button,
    {
      className,
      size: "m",
      variant: "plain",
      color: "secondary",
      isDisabled,
      "data-component": "toggleRevealPassword",
      children: [
        icon,
        /* @__PURE__ */ jsx(Tooltip, { children: tooltipText })
      ]
    }
  ) }) });
};

export { TogglePasswordVisibilityButton, TogglePasswordVisibilityButton as default };
//# sourceMappingURL=TogglePasswordVisibilityButton.mjs.map
